import React, { useState, useEffect } from 'react'
import { prepareData } from 'utils/googleData'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useTranslatedProps } from 'utils/translateProps'
import QuickContactModal from './QuickContactModal'
import sampleConfig from './quickcontact-sample.json'

export interface FormField {
    name: string
    placeholder: string
    placeholder_ar?: string
    component: string
    hubspotField: string
    enable?: boolean
    optional?: boolean
    options?: Array<{
        value?: string
        hubspotValue: string | number
        label?: string
        label_ar?: string
    }>
    type?: string
}

export interface QuickContactProps {
    enable?: string
    title?: string
    title_ar?: string
    title_en?: string
    subtitle?: string
    subtitle_ar?: string
    subtitle_en?: string
    formUrl?: string
    direction?: 'rtl' | 'ltr' | 'auto'
    cta?: {
        label: string
    }
    formFields?: Array<FormField>
    confirmationTitle?: {
        title: string
        title_ar?: string
        subtitle: string
        subtitle_ar?: string
        description: string
        description_ar?: string
    }
    confirmationMessageCTA?: {
        title: string
        title_ar?: string
        url: string
    }
    isOpen?: boolean
    onClose?: () => void
    onSubmitSuccess?: () => void
    useSampleConfig?: boolean
}

export function QuickContact(props: QuickContactProps) {
    const { i18n } = useTranslation()
    const configProps = props.useSampleConfig ? sampleConfig.QuickContact.allQuickContact : props

    // Use our new translation utility
    const translatedProps = useTranslatedProps(configProps, i18n.language)

    const isOpen = props.isOpen
    const onClose = props.onClose
    const onSubmitSuccess = props.onSubmitSuccess
    const { enable, title, subtitle, formUrl, formFields, confirmationTitle, confirmationMessageCTA } = translatedProps

    // Transform CTA array to single object if needed
    const cta = Array.isArray(translatedProps.cta)
        ? { label: translatedProps.cta[0]?.label || 'Submit' }
        : translatedProps.cta

    const [isModalOpen, setIsModalOpen] = useState(isOpen || false)
    useEffect(() => {
        setIsModalOpen(isOpen || false)
    }, [isOpen])

    const handleClose = () => {
        setIsModalOpen(false)
        onClose?.()
    }

    return (
        <QuickContactModal
            isOpen={isModalOpen}
            onClose={handleClose}
            onSubmitSuccess={onSubmitSuccess}
            title={title}
            subtitle={subtitle}
            formUrl={formUrl}
            formFields={formFields}
            confirmationTitle={confirmationTitle}
            confirmationMessageCTA={confirmationMessageCTA}
            direction={props.direction}
            cta={cta}
        />
    )
}

export default QuickContact
